import { NextRouter } from 'next/router'
import { useEffect, useState } from 'react'

// 吐回去的 Index 需搭配 react-virtualized List component 的 scrollToIndex 的 props 使用
export const useVirtualizedScrollRestoration = (router: NextRouter, { listRef }: { listRef?: any }) => {
  const sessionStorageItemKey = `viewList:${router.asPath}-${history.state.key}`
  const sessionStorageViewedIndex = sessionStorage.getItem(sessionStorageItemKey)
  const [viewedRowIndex, setViewedRowIndex] = useState<number | null>(null)

  useEffect(() => {
    const saveScrollIndex = (url: string) => {
      const currentUrl = `/${router.locale}${router.asPath}`

      const newAsPathWitoutQuery = currentUrl.split('?')[0]
      const currentAsPathWitoutQuery = currentUrl.split('?')[0]

      if (currentUrl === url || newAsPathWitoutQuery === currentAsPathWitoutQuery) {
        return
      }
      const indexByInstance = Math.round((listRef?.current?.Grid._rowStartIndex + listRef?.current?.Grid._rowStopIndex) / 2)

      // viewedRowIndex 是點擊卡片導頁時紀錄
      // indexByInstance 是自己算出的 index，但這個取法有可能會跟原本位置有偏差
      // 所以能用 viewedRowIndex 還是要用
      const storeIndex = viewedRowIndex ? viewedRowIndex : indexByInstance
      storeIndex && sessionStorage.setItem(sessionStorageItemKey, `${storeIndex}`)
    }

    router.events.on('routeChangeStart', saveScrollIndex)

    return () => {
      router.events.off('routeChangeStart', saveScrollIndex)
    }
  }, [router, viewedRowIndex])
  useEffect(() => {
    const sessionStorageItemKey = `viewList:${router.asPath}-${history.state.key}`
    sessionStorage.removeItem(sessionStorageItemKey)
  }, [])

  return { scrollToIndex: sessionStorageViewedIndex ? Number(sessionStorageViewedIndex) : undefined, setViewedRowIndex: setViewedRowIndex }
}
